import React from 'react'
import { Link } from 'react-router-dom'

// components
import AccountButton from 'components/atoms/AccountButton'

// styling
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

export default function ResponsiveButton(props) {
  // display full width button on mobile
  const theme = useTheme()
  const fullWidth = useMediaQuery(theme.breakpoints.down('sm'))

  // use React router Link when 'to' prop is provided. Otherwise, use <a href=...
  const { to, align } = props
  const component = to ? Link : 'a'

  return (
    <AccountButton
      variant='contained'
      component={component}
      fullWidth={fullWidth}
      sx={{
        marginTop: {
          xs: 1,
          sm: 0
        },
        marginBottom: 0,
        marginRight: {
          xs: 0,
          sm: align == 'right' ? 0 : 1
        },
        marginLeft: {
          xs: 0,
          sm: align == 'left' ? 0 : 1
        }
      }}
      {...props}
    />
  )
}
